//find polyfill
Array.prototype.find = Array.prototype.find || function (callback) {
    if (this === null) {
        throw new TypeError('Array.prototype.find called on null or undefined');
    } else if (typeof callback !== 'function') {
        throw new TypeError('callback must be a function');
    }
    var list = Object(this);
    // Makes sures is always has an positive integer as length.
    var length = list.length >>> 0;
    var thisArg = arguments[1];
    for (var i = 0; i < length; i++) {
        var element = list[i];
        if (callback.call(thisArg, element, i, list)) {
            return element;
        }
    }
};

//startsWith polyfill
if (!String.prototype.startsWith) {
    Object.defineProperty(String.prototype, 'startsWith', {
        value: function (search, rawPos) {
            var pos = rawPos > 0 ? rawPos | 0 : 0;
            return this.substring(pos, pos + search.length) === search;
        }
    });
}

//array.from polyfill
if (!Array.from) {
    Array.from = (function () {
        var toStr = Object.prototype.toString;
        var isCallable = function (fn) {
            return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
        };
        var toInteger = function (value) {
            var number = Number(value);
            if (isNaN(number)) {
                return 0;
            }
            if (number === 0 || !isFinite(number)) {
                return number;
            }
            return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
        };
        var maxSafeInteger = Math.pow(2, 53) - 1;
        var toLength = function (value) {
            var len = toInteger(value);
            return Math.min(Math.max(len, 0), maxSafeInteger);
        };

        // The length property of the from method is 1.
        return function from(arrayLike/*, mapFn, thisArg */) {
            // 1. Let C be the this value.
            var C = this;

            // 2. Let items be ToObject(arrayLike).
            var items = Object(arrayLike);

            // 3. ReturnIfAbrupt(items).
            if (arrayLike == null) {
                throw new TypeError("Array.from requires an array-like object - not null or undefined");
            }

            // 4. If mapfn is undefined, then let mapping be false.
            var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
            var T;
            if (typeof mapFn !== 'undefined') {
                // 5. else
                // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
                if (!isCallable(mapFn)) {
                    throw new TypeError('Array.from: when provided, the second argument must be a function');
                }

                // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
                if (arguments.length > 2) {
                    T = arguments[2];
                }
            }

            // 10. Let lenValue be Get(items, "length").
            // 11. Let len be ToLength(lenValue).
            var len = toLength(items.length);

            // 13. If IsConstructor(C) is true, then
            // 13. a. Let A be the result of calling the [[Construct]] internal method of C with an argument list containing the single item len.
            // 14. a. Else, Let A be ArrayCreate(len).
            var A = isCallable(C) ? Object(new C(len)) : new Array(len);

            // 16. Let k be 0.
            var k = 0;
            // 17. Repeat, while k < len… (also steps a - h)
            var kValue;
            while (k < len) {
                kValue = items[k];
                if (mapFn) {
                    A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
                } else {
                    A[k] = kValue;
                }
                k += 1;
            }
            // 18. Let putStatus be Put(A, "length", len, true).
            A.length = len;
            // 20. Return A.
            return A;
        };
    }());
}

//includes polyfill
if (!String.prototype.includes) {
    String.prototype.includes = function (search, start) {

        if (search instanceof RegExp) {
            throw TypeError('first argument must not be a RegExp');
        }
        if (start === undefined) {
            start = 0;
        }
        return this.indexOf(search, start) !== -1;
    };
}

//array.includes polyfill
Array.prototype.includes || Object.defineProperty(Array.prototype, "includes", {
    value: function (r, e) {
        if (null == this) throw new TypeError('"this" is null or not defined');
        var t = Object(this), n = t.length >>> 0;
        if (0 === n) return !1;
        var i, o, a = 0 | e, u = Math.max(0 <= a ? a : n - Math.abs(a), 0);
        for (; u < n;) {
            if ((i = t[u]) === (o = r) || "number" == typeof i && "number" == typeof o && isNaN(i) && isNaN(o)) return !0;
            u++
        }
        return !1
    }
});

//ForEach polyfill
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

//SVG xlink:href polyfil https://github.com/jonathantneal/svg4everybody
document.addEventListener('DOMContentLoaded', () => {
    svg4everybody();
});

var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

function debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, timeout);
    };
}

class BaseClass {
    constructor(element) {
        this.element = element;
        this.element.wrapper = this;
        this.eventListeners = [];
    }

    addEventListener(eventType, callback) {
        this.eventListeners.push({
            eventType, callback
        });
    }

    raiseEvent(eventType, data = undefined) {
        this.eventListeners
            .filter(x => x.eventType === eventType)
            .forEach(x => x.callback(data));
    }
}


//toggle class
function toggleClass(el, className) {
    if (el.classList) {
        el.classList.toggle(className);
    } else {
        var classes = el.className.split(' ');
        var existingIndex = classes.indexOf(className);

        if (existingIndex >= 0)
            classes.splice(existingIndex, 1);
        else
            classes.push(className);

        el.className = classes.join(' ');
    }
}


//toggle data class
document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll("[data-tc-target]").forEach(i => {

        i.addEventListener('click', e => {

            e.preventDefault();

            let targetElement = e.target.dataset.tcTarget;

            let setClass = e.target.dataset.tcClass;
            if (setClass === undefined) {
                setClass = 'open';
            }

            document.querySelectorAll(targetElement).forEach(t => {
                t.classList.toggle(setClass);
            });

            if (e.target.dataset.tcHtmlOverflow) {
                document.querySelector('html').classList.toggle(e.target.dataset.tcHtmlOverflow);
            }

        })
    });

});


function elementContentOverflows(element) {

    const parentWidth = element.getBoundingClientRect().width;
    const childElements = element.querySelectorAll(`:scope > *`);
    let childElementTotalWidth = 0;

    childElements.forEach(i => {
        const currentItemStyling = window.getComputedStyle(i);
        const currentItemWidth = parseFloat(currentItemStyling.width) + parseFloat(currentItemStyling.marginLeft) + parseFloat(currentItemStyling.marginRight);
        childElementTotalWidth += currentItemWidth;
    });

    return (parseInt(childElementTotalWidth) > parseInt(parentWidth));

}

function clearCookieValue(name) {
    document.cookie = `${name}=""`;
}

document.addEventListener('DOMContentLoaded', () => {
    openJobModal();
})

function openJobModal() {
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop)
    });
    let jobId = params.job;
    if (jobId) {
        autoOpenModal(jobId);
    }
}
class DetectTab {
    constructor() {
        this.isKeyboard = false;
        this.bindEvents();
    }

    bindEvents() {
        document.addEventListener('keydown', event => {
                if (event.key === 'Tab') {
                    this.setKeyboard()
                }
            }
        );
        document.addEventListener('click', () => this.setMouse());
    }

    setKeyboard() {
        if (!this.isKeyboard) {
            document.querySelector('body').classList.add('keyboard-input');
            this.isKeyboard = true;
        }
    }

    setMouse() {
        if (this.isKeyboard) {
            document.querySelector('body').classList.remove('keyboard-input');
            this.isKeyboard = false;
        }
    }

}

function AddSkipLink() {
    const link = `<a class="skip-link" href="#maincontent">Skip to main</a>`
    document.querySelector('body').insertAdjacentHTML(`afterbegin`, link);
}

document.addEventListener('DOMContentLoaded', () => {
    new DetectTab;
    AddSkipLink();
});
class ScrollFix{
    constructor(el, target) {
        this.link = el;
        this.hash = target;
        this.target = document.querySelector(target);
        this.bindEvents();
    }

    bindEvents(){
        this.link.addEventListener("click", e => {
            e.preventDefault();
            if(this.target.classList.contains("detect-in-view")){
                this.target.classList.remove("detect-in-view");
            }
            this.target.querySelectorAll(".detect-in-view").forEach(target =>{
                target.classList.remove("detect-in-view");
            })
            window.location = location.pathname + this.hash;
        })
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll("a[href]").forEach(link =>{
        let href = link.getAttribute("href");
        if(href.length > 1 && href.split("")[0] === "#" && (document.querySelector(href) !== null)){
            new ScrollFix(link, href);
        }
    })
});
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(`.brochure-form input[type=submit]`).forEach(el => addEventListener('click', () => clearCookieValue('brochureIds')));
});
class BrochurePicker extends BaseClass {
    constructor(el) {
        super(el);
        this.component = el;

        this.selectBar = this.component.querySelector(`[data-select]`);
        this.countText = this.selectBar.querySelector(`[data-count]`);

        this.brochures = this.component.querySelectorAll(`[data-brochure]`);

        this.selectedIds = [];

        this.init();

        this.bindEvents();
    }

    init() {

        let cookieValue;

        if (document.cookie !== undefined && document.cookie.includes('brochureIds=') === true) {
            cookieValue = document.cookie
                .split('; ')
                .find(row => row.startsWith('brochureIds='))
                .split('=')[1];
        }

        this.brochures.forEach(el => {

            el.button = el.querySelector(`[data-add-button]`);

            const brochureId = el.dataset.brochureId
            el.brochureId = brochureId;

            if (`,${cookieValue},`.includes(`,${brochureId},`)) {
                el.classList.add('selected');
                this.selectedIds.push(brochureId);
            }
        });

        this.updateButton();

    }

    bindEvents() {
        this.brochures.forEach(el => {
            el.addEventListener(
                'click',
                () => {
                    toggleClass(el, 'selected');
                    this.toggleId(el.brochureId);
                }
            )
        })
    }

    updateButton() {

        const brochureCount = this.selectedIds.length;
        this.countText.textContent = `${brochureCount} Brochure${(brochureCount !== 1) ? 's' : ''} Selected`;

        if (brochureCount > 0) {
            this.selectBar.classList.add('open');
        } else {
            this.selectBar.classList.remove('open');
        }

    }

    toggleId(id) {

        const oldArray = this.selectedIds;

        if (oldArray.includes(id)) {
            this.selectedIds = oldArray.filter(el => el !== id);
        } else {
            this.selectedIds.push(id);
        }

        this.setCookie();
        this.updateButton();

        this.raiseEvent("listUpdated", this.selectedIds);

    }

    setCookie() {
        document.cookie = `brochureIds=${this.selectedIds.toString()}`;
    }

}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(`[data-brochure-list]`).forEach(el => {
        el.func = new BrochurePicker(el);
        //brochurePicker.addEventListener('listUpdated', (selectedIds) => console.log(`Brochure IDs ${selectedIds}`));  //do stuff here
    });
});
document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('[data-browser-warning]').forEach(el => {
        el.querySelector('[data-close]').addEventListener('click', () => {
            document.cookie="browserWarningClosed=true";
            el.remove();
        })
    })

})
class FlagPanel extends BaseClass {
    constructor(element, options = {}) {
        super(element);
        this.options = options;

        this.defaultOptions = {
            inputSelector: 'input'
        };

        this.finalOptions = {...this.defaultOptions, ...this.options};

        this.bindStart();
    }

    bindStart() {

        this.element.addEventListener('click', () => {
            this.init();
            this.bindEvents();
            this.setChecked();
        }, {
            once: true
        });

    }

    init() {

        this.items = this.element.querySelectorAll(this.finalOptions.inputSelector);
        this.element.classList.add('loaded');

    }

    bindEvents() {

        this.items.forEach(el => {
            el.addEventListener('input', () => this.setChecked());
        });

        window.addEventListener("resize", () => this.setChecked());

    }

    setChecked() {

        let checkedItem;

        this.items.forEach(el => {
            if (el.checked !== false) checkedItem = el;
        })

        const relatedPane = checkedItem.nextElementSibling;

        const boundingBoxLeft = (this.element.getClientRects().length === 0) ? 0 : (this.element.getClientRects()[0].left + 1);

        const paneArea = {
            left: relatedPane.getClientRects()[0].left,
            width: relatedPane.getClientRects()[0].width
        }

        this.element.style.setProperty('--left', `${paneArea.left - boundingBoxLeft}px`);
        this.element.style.setProperty('--width', `${paneArea.width}px`);

    }

}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-flag-panel]').forEach(el => {
        let flagPanel = new FlagPanel(el);
        el.classFunc = flagPanel;
    });
});
document.addEventListener('DOMContentLoaded', () => {

    window.addEventListener("load", () => {
        var cookieSettings = document.querySelector("[data-cookie-settings]");
        if (cookieSettings) {
            var show = cookieSettings.dataset.show;

            if (show === "1") {
                window.cookieconsent.initialise({
                    "position": "floating",
                    content: {
                        message: cookieSettings.dataset.msg,
                        dismiss: cookieSettings.dataset.dismiss,
                        allow: 'Allow cookies',
                        deny: 'Decline',
                        link: cookieSettings.dataset.linktext,
                        href: cookieSettings.dataset.url,
                        target: '_blank',
                    }
                })
            }
        }



    });

})
class CountDown{
    constructor(el, toDate) {
        this.scope = el;
        this.toDate = toDate;
        this.dayWrapper = el.querySelector("[data-days]");
        this.hourWrapper = el.querySelector("[data-hours]");
        this.minuteWrapper = el.querySelector("[data-minutes]");
        this.secondWrapper = el.querySelector("[data-seconds]");

        this.init();
    }

    init(){
        if(Date.parse(this.toDate) > new Date()){
            this.count();
        }else{
            this.minuteWrapper.dataset.value = "0";
            this.hourWrapper.dataset.value = "0";
            this.dayWrapper.dataset.value = "0";
            this.secondWrapper.dataset.value = "0";
        }

    }

    count(){
        this.timeinterval = setInterval(counting, 1000);
        let that = this;
        function counting () {

            that.minuteWrapper.dataset.value = that.parseDate().minutes;
            that.hourWrapper.dataset.value = that.parseDate().hours;
            that.dayWrapper.dataset.value = that.parseDate().days;
            that.secondWrapper.dataset.value = that.parseDate().seconds;

            if (
                that.parseDate().minutes === 0 &&
                that.parseDate().hours === 0 &&
                that.parseDate().days === 0 &&
                that.parseDate().seconds === 0
            ) {
                clearInterval(that.timeinterval);
            }
        }

    }


    parseDate(){
        const total = Date.parse(this.toDate) - Date.parse(new Date());
        const days = Math.floor(total / (1000 * 60 * 60 * 24));
        const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        const seconds = Math.floor((total / 1000) % 60);

        return {
            days: days,
            hours: hours,
            minutes: minutes,
            seconds: seconds
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-countdown-to]').forEach(el => {
        new CountDown(el, el.dataset.countdownTo)
    });
});
document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('[data-date-picker]').forEach(i => {

        let monthsToDisplay = (queryViewport() === "xs" || queryViewport() === "sm") ? 1 : 2;

        flatpickr(i, {
            showMonths: monthsToDisplay,
            minDate: "today",
            dateFormat: "d-m-Y",
            static: true,
            monthSelectorType: 'static',
            "locale": {
                "firstDayOfWeek": 1
            }
        });
    });

    document.querySelectorAll('[data-time-picker]').forEach(i => {
        flatpickr(i, {
            enableTime: true,
            noCalendar: true,
            dateFormat: "H:i",
            time_24hr: true
        });
    });

})
class DetectInView {
    constructor(element) {
        this.element = element;
        this.init();
        this.observe();
    }

    init() {
        this.element.classList.add('detect-in-view')
    }

    observe() {

        const intersectionObserver = new IntersectionObserver(entries => {
            if (entries[0].intersectionRatio <= 0) return;
            setTimeout(
                () => this.element.classList.add('is-in-view')
                ,75
            );
            intersectionObserver.unobserve(this.element);
        });

        intersectionObserver.observe(this.element);

    }

}


document.addEventListener('DOMContentLoaded', () => {

    if (!('IntersectionObserver' in window) ||
        !('IntersectionObserverEntry' in window) ||
        !('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
    } else {
        document.querySelectorAll('[data-detect-in-view]').forEach(el => new DetectInView(el));
    }

});
document.addEventListener('DOMContentLoaded', function () {

    const viewportTestElement = document.createElement('div');
    viewportTestElement.classList.add('detect-viewport');
    document.querySelector('body').appendChild(viewportTestElement);

});

function queryViewport() {
    const viewportTestEl = window.getComputedStyle(document.querySelector('.detect-viewport'));

    if (viewportTestEl.marginTop === '50px') {
        return 'xxl'
    }

    if (viewportTestEl.marginTop === '40px') {
        return 'xl'
    }

    if (viewportTestEl.marginTop === '30px') {
        return 'lg'
    }

    if (viewportTestEl.marginTop === '20px') {
        return 'md'
    }

    if (viewportTestEl.marginTop === '10px') {
        return 'sm'
    }

    if (viewportTestEl.marginTop === '1px') {
        return 'xs'
    }
}
class Header {
    constructor() {
        this.overlay = document.querySelector(`[data-overlay]`);

        this.searchForm = document.querySelector(`.header__search-form`);
        this.searchFormOpen = false;
        this.searchToggles = document.querySelectorAll(`[data-toggle-search]`);

        this.navOpen = false;

        this.navBars = document.querySelector(`[data-menu-bars]`);

        this.navWrap = document.querySelector(`.nav-wrap`);

        //group one
        this.levelOneItems = document.querySelectorAll(`.nav-wrap > .nav > .nav__l1 > li > [data-toggle-sub-nav]`);
        this.levelOneItemsUpper = document.querySelectorAll(`.header__upper__nav-wrap > .nav > .nav__l1 > li > [data-toggle-sub-nav]`);
        this.backBars = document.querySelectorAll(`.nav__back-bar[data-toggle-sub-nav]`);

        //group two
        this.levelTwoItemsTrigger = document.querySelectorAll(`.nav-wrap .nav__l2 > li > [data-toggle-sub-nav]`);
        this.levelTwoItems = document.querySelectorAll(`.nav-wrap .nav__l2 li`);

        this.init();
        this.bindEvents();
    }

    init() {

        //group one
        this.levelOneItems.forEach(el => {
            const targetId = el.dataset.toggleSubNav;
            el.subNav = document.querySelector(`.nav-wrap [data-sub-nav="${targetId}"]`);
        });
        this.levelOneItemsUpper.forEach(el => {
            const targetId = el.dataset.toggleSubNav;
            el.subNav = document.querySelector(`.nav-wrap [data-sub-nav="${targetId}"]`);
        });
        this.backBars.forEach(el => {
            const targetId = el.dataset.toggleSubNav;
            el.subNav = document.querySelector(`.nav-wrap [data-sub-nav="${targetId}"]`);
        });

        //group two
        this.levelTwoItemsTrigger.forEach(el => {
            const targetId = el.dataset.toggleSubNav;
            el.subNav = document.querySelector(`.nav-wrap [data-sub-nav="${targetId}"]`);
        });
    }

    bindEvents() {

        this.overlay.addEventListener('click', () => this.closeAll());

        //group one
        this.levelOneItems.forEach(el => el.addEventListener('click', () => this.toggleLevelOneItems(el.subNav)));
        this.levelOneItemsUpper.forEach(el => el.addEventListener('click', () => this.toggleLevelOneItemsUpper(el.subNav, el)));
        this.backBars.forEach(el => el.addEventListener('click', () => this.toggleLevelOneItems(el.subNav)));

        //group two
        this.levelTwoItemsTrigger.forEach(el => el.addEventListener('click', () => this.toggleLevelTwoItems(el.subNav, 'click')));
        this.levelTwoItemsTrigger.forEach(el => el.addEventListener('mouseover', () => this.toggleLevelTwoItems(el.subNav, 'mouseover')));

        this.searchToggles.forEach(el => el.addEventListener('click', () => this.toggleSearchForm()));

        this.navBars.addEventListener('click', () => this.toggleNav());
    }

    toggleNav() {
        const initialNavOpenState = this.navOpen;
        this.closeAll();
        if (!initialNavOpenState) {
            this.overlay.classList.add('open');
            document.querySelector('html').classList.add('header--nav-open');
            this.navOpen = true;
        }
    }

    toggleLevelTwoItems(subNav, type) {
        if (type === 'mouseover') {
            if ((queryViewport() === "xl") || (queryViewport() === "xxl")) {
                this.levelTwoItems.forEach(el => el.classList.remove('open'));
                toggleClass(subNav, 'open');
                this.overlay.classList.add('open');
            }
        } else {
            if (!(queryViewport() === "xl") || !(queryViewport() === "xxl")) {
                this.levelTwoItems.forEach(el => el.classList.remove('open'));
                toggleClass(subNav, 'open');
                this.overlay.classList.add('open');
            }
        }
    }

    toggleLevelOneItems(subNav) {
        toggleClass(subNav, 'open');
    }

    toggleLevelOneItemsUpper(subNav, trigger) {

        const storeActive = Array.from(this.levelOneItemsUpper).filter(el => el.isOpen === true);

        this.closeAll();
        this.overlay.classList.add('open');

        if (storeActive[0] === trigger) {
            trigger.isOpen = false;
            this.overlay.classList.remove('open');
        } else {
            trigger.isOpen = true;
            trigger.classList.add('active');
            subNav.classList.add('open');
            this.navWrap.classList.add('open')
            this.navOpen = true;
            const subSubNavs = subNav.querySelectorAll(`ul > [data-sub-nav] > button[data-toggle-sub-nav]`);
            if (subSubNavs.length > 0) {
                subSubNavs[0].parentNode.classList.add('open');
            }
        }

    }

    toggleSearchForm() {
        const storeActive = this.searchFormOpen;
        this.closeAll();
        if (!storeActive) {
            this.overlay.classList.add('open');
            this.searchForm.classList.add('open');
            this.searchFormOpen = true;
        }
    }

    closeAll() {

        this.levelOneItemsUpper.forEach(el => {
            el.classList.remove('active');
            el.isOpen = false;
        });

        document.querySelector('html').classList.remove('header--nav-open');

        this.overlay.classList.remove('open');

        let navItems = document.querySelectorAll(`.header .open`);
        navItems.forEach(el => el.classList.remove('open'));

        this.searchForm.classList.remove('open');
        this.searchFormOpen = false;

        this.navOpen = false;
    }

}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.header').forEach(() => new Header())
});
var Modal = {
    "current": null,
    "init": function (el, options) {
        Modal.bindEvents(el, options);
        return this;
    },
    "bindEvents": function (el, options) {
        Modal.attachClickEvent(el, options);
    },
    "attachClickEvent": function (el, options) {
        el.addEventListener("click", function (event) {
            event.preventDefault();

            if (Modal.create(el, options) === true) {
                Modal.open(el, options);
            }
        });
    },
    "create": function (el, options) {

        let targetContent = el.dataset.modal;

        var title = el.dataset.modalTitle;
        var close = el.dataset.modalHideClose;
        var type = el.dataset.modalType;
        var isAlt = el.dataset.modalAlt;
        var classes = el.dataset.modalClasses;
        var location = el.dataset.modalLocation;

        let hasAltHeader = false;
        if (el.dataset.modalAltHeader === "true") hasAltHeader = true;

        var modalHTMLTitle = (title) ? '<div class="modal__title set-h4">' + title + '</div>' : '';
        var modalHTMLClose = (!close) ? '<span class="modal__close icon times" data-modal-close></span>' : '';
        var modalHTMLType = (type) ? 'sidebar' : '';
        var modalHTML = '<div class="modal__inner">' + modalHTMLClose + modalHTMLTitle + '<div class="modal__content"></div></div>';

        var m = Modal.current = document.createElement("div");
        m.classList.add("modal");
        if (modalHTMLType) {
            m.classList.add("modal--sidebar");
        }
        if (hasAltHeader) {
            m.classList.add("modal--has-alt-header");
        }
        if (isAlt) {
            m.classList.add("modal--alt");
        }

        if (classes) {
            classes.split(",").forEach(themeClass => m.classList.add(themeClass));
        }

        if (location) {
            history.pushState({}, "", location);
        }

        m.innerHTML = modalHTML;

        document.body.appendChild(m);

        m.addEventListener("click", function (e) {
            if (e.target !== this)
                return false;

            Modal.close(el, options);
            Modal.destroy(el, options);
        });
        return true;
    },
    "destroy": function (el, options) {
        Modal.current.parentNode.removeChild(Modal.current);
    },
    "open": function (el, options) {

        event.stopPropagation();

        let container = document.querySelector('.modal');

        container.classList.toggle('modal--open')
        Modal.addContent(el, options);

        document.querySelectorAll('[data-modal-close]').forEach(i => {
            i.addEventListener("click", function (e) {
                Modal.close(el, options);
                Modal.destroy(el, options);
            });
        });

        document.querySelector('html').classList.toggle('modal-overlay')

        if (options.onOpen !== undefined) {
            options.onOpen(container);
        }

    },
    "close": function (el, options) {
        let container = document.querySelector('.modal');
        const onClosingEvent = window[el.dataset.modalOnClosing];
        if (typeof onClosingEvent === "function") {
            onClosingEvent();
        }

        container.classList.toggle('modal--open')
        document.querySelector('html').classList.toggle('modal-overlay');

        if (options.onClose !== undefined) {
            options.onClose(container);
        }
    },
    "addContent": function (el, options) {

        let content = el.dataset.modal;

        if(el.dataset.modalMethod === "fetch"){
            fetch(el.dataset.modal).then(response => {
                return response.text();
            }).then(data => {
                Modal.current.querySelector('.modal__content').innerHTML = data;
                const onAppearEvent = window[el.dataset.modalOnAppear];
                if (typeof onAppearEvent === "function") {
                    onAppearEvent();
                }
            });
        }else{
            let contentHTML = document.querySelector(content).outerHTML;
            //     //de-dupe ids
            contentHTML = contentHTML.replace(/id="/g, 'id="modal-');
            contentHTML = contentHTML.replace(/for="/g, 'for="modal-');
            Modal.current.querySelector('.modal__content').innerHTML = contentHTML;

        }
    }
};


//modal functionality
document.addEventListener('DOMContentLoaded', () => {

    //standard modal
    document.querySelectorAll("[data-modal]").forEach(el => {
        let modal = Modal.init(el, {
            "onOpen": (container) => modalOpenCallback(container)
        });

    });

});


function modalOpenCallback(container) {

    //trigger stuff
    //dropzone:
    let dropZonesWrap = container.querySelectorAll("[data-dropzone-wrap]");
    dropZonesWrap.forEach(i => triggerDropzones(i));

    //date picker
    container.querySelectorAll('[data-date-picker]').forEach(i => {
        flatpickr(i, {
            dateFormat: "d/m/Y"
        });
    });

    container.querySelectorAll("[data-select-type='choicesjs']").forEach(el => {
        if (el.closest('.modalcontent') === null) {
            let choices = new Choices(el,
                {
                    removeItemButton: true,
                    itemSelectText: "",
                    placeholderValue: "Please select...",
                    searchEnabled: false
                });
        }
    });

    //other modals
    container.querySelectorAll("[data-modal]").forEach(el => {
        let modal = Modal.init(el, {
            "onOpen": (container) => modalOpenCallback(container)
        });
    });

    //map
    container.querySelectorAll("[data-map]").forEach(el => {
        initMap(el);
    });

    container.querySelectorAll(`[data-form-with-confirmation]`).forEach(formWrap => {
        const form = formWrap.querySelector(`[data-form-with-confirmation--form]`);
        const confirmation = formWrap.querySelector(`[data-form-with-confirmation--confirmation]`);
        formWrap.displayConfirmation = () => {
            form.classList.remove(`form-with-confirmation__pane--open`);
            confirmation.classList.add(`form-with-confirmation__pane--open`)
        }
    })
}

function openForm() {
    document.querySelectorAll(`.modal--open [data-form-with-confirmation]`).forEach(formWrap => {
        const container = formWrap.querySelector(`[data-form-with-confirmation--form]`);
        const confirmation = formWrap.querySelector(`[data-form-with-confirmation--confirmation]`);
        const modalToggle = document.querySelector("[data-modal-toggle]");

        formWrap.displayConfirmation = () => {
            container.classList.remove(`form-with-confirmation__pane--open`);
            confirmation.classList.add(`form-with-confirmation__pane--open`)
            const formContent = document.querySelector("[data-modal-form-content]")
            const title = formContent.dataset["modalFormContent"]

            const hubspotForm = document.querySelector(`[data-hubspot-modal='${title}']`)
            if (hubspotForm) {
                const cont = hubspotForm.querySelector("[data-hubspot-content]")
                formContent.insertAdjacentElement("afterbegin", cont)
            } else {
                const uForm = document.querySelector(`[data-uform-modal='${title}']`);
                if (uForm) {
                    const cont = uForm.querySelector(".form-page__form")
                    formContent.insertAdjacentElement("afterbegin", cont)
                    const form = formContent.querySelector("form");
                    form.action = uForm.dataset.formLocation;
                }
            }
        }
        const formContent = document.querySelector("[data-modal-form-content]")
        const title = formContent.dataset["modalFormContent"]
        const uForm = document.querySelector(`[data-uform-modal='${title}']`);
        modalToggle.addEventListener("click", formWrap.displayConfirmation)

        if (uForm.querySelectorAll('.field-validation-error').length){
            setTimeout(() =>  formWrap.displayConfirmation(), 150)

        }
    })
}

function closeForm() {
    const formContent = document.querySelector("[data-modal-form-content]")
    const title = formContent.dataset["modalFormContent"]
    const hubspotForm = document.querySelector(`[data-hubspot-modal='${title}']`)

    if (hubspotForm) {
        const cont = formContent.querySelector("[data-hubspot-content]")
        if (cont) {
            hubspotForm.insertAdjacentElement("afterbegin", cont)
        }
    } else {
        const uForm = document.querySelector(`[data-uform-modal='${title}']`);
        if (uForm) {
            const cont = formContent.querySelector(`.form-page__form`);
            if (cont) {
                uForm.insertAdjacentElement("afterbegin", cont)
            }
        }
    }
}

function autoOpenModal(modalId) {

    const modalTriggerButton = document.querySelector(`[data-modal][data-modal-id="${modalId}"]`);

    if (modalTriggerButton) {

        modalTriggerButton.focus();

        setTimeout(() => {
            modalTriggerButton.click();
        }, 500);
    } else {
        console.error(`modal trigger button id not found: '[data-modal][data-modal-id="${modalId}"]'`);
    }

}
class SvgReplacer extends BaseClass {

    constructor(image) {
        super(image);
        this.image = image;
        this.imageSrc = this.image.src;
        this.newImageSrc = document.createElement("div");
        this.getSourceString();
    }

    getSourceString() {
        window.fetch(this.imageSrc)
            .then(response => response.text())
            .then(body => {
                this.newImageSrc.innerHTML = body;
                let svg = this.newImageSrc.querySelector("svg");
                if(svg !== undefined){
                    this.newImageSrc.querySelector("svg").classList = this.image.classList;
                    this.doReplace();
                }
            });
    }

    doReplace() {
        this.image.insertAdjacentHTML("afterend", this.newImageSrc.innerHTML);
        this.image.parentNode.removeChild(this.image);
        this.raiseEvent("replaced");
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-svg-src]').forEach(el => {
        new SvgReplacer(el);
    });
});

document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('[data-picture-slider]').forEach(i => {

        const removeGutter = (width) => width - (15 * 2);

        let slider = tns({
            nav: false,
            container: i.querySelector('[data-items]'),
            controlsContainer: i.querySelector('[data-controls]'),
            loop: true,
            gutter: 40,
            responsive: {
                576: {
                    fixedWidth: removeGutter(458),
                    center: true
                },
                768: {
                    fixedWidth: removeGutter(458)
                },
                992: {
                    fixedWidth: removeGutter(552)
                },
                1200: {
                    fixedWidth: removeGutter(552)
                },
                1440: {
                    fixedWidth: removeGutter(636)
                }
            }
        });

        i.sliderFunc = slider;

    });

});
class ResourceSlider extends BaseClass {
    constructor(i, items, controls, count, playControls, progressBar) {
        super(i);
        this.wrap = i;
        this.items = items;
        this.prevButton = controls.querySelector("[data-prev]");
        this.nextButton = controls.querySelector("[data-next]");
        this.count = count;
        this.playControls = playControls;
        this.progressBar = progressBar;
        this.style = this.wrap.dataset.slider;
        this.playing = true;
        this.minHeight = 0;
        this.options = {
            nav: false,
            container: this.items,
            prevButton: this.prevButton,
            nextButton: this.nextButton,
            speed: 800,
            mode: "gallery",
            autoHeight: false,
            autoplay: false,
            loop: true,
            items: 1,
            onInit: ()=>{
                this.stop()
                this.start()
            }
        };

        this.slide = () =>{
            this.stop();
            this.sliderObject.goTo('next');
        }
        this.setMinHeight();
        this.buildSlider();
        this.bindEvents();
    }

    setMinHeight(){
        this.wrap.style.minHeight = "0px";
        this.minHeight = 0;
        Array.prototype.slice.call(this.items.children).forEach(slide =>{
            if(slide.offsetHeight > this.minHeight) this.minHeight = slide.offsetHeight;
        })
        this.wrap.style.minHeight = `${this.minHeight}px`;
    }

    updateIndex(index, total){
        //processor.Run();
        this.count.innerHTML = `${index} of ${total}`;
    }

    buildSlider() {

        this.sliderObject = tns(this.options);

        this.sliderObject.events.on('indexChanged', e=> this.updateIndex(e.displayIndex, e.slideCount));
        this.sliderObject.events.on('transitionStart', ()=> this.playing && this.stop());

        this.sliderObject.events.on('transitionEnd', ()=> this.playing && this.start());

        this.wrap.sliderFunc = this.sliderObject;


        this.resizeFunction = debounce(e => {
            this.setMinHeight();
        }, 100).bind(this);

        window.addEventListener("resize", e => {
            this.resizeFunction();
        });

        this.updateIndex(this.sliderObject.getInfo().displayIndex, this.sliderObject.getInfo().slideCount);

    }


    bindEvents(){
        this.playControls.addEventListener("click", ()=>{
            if(this.playing){
                this.wrap.classList.add("resource-slider--pause");
                this.playing = false;
                this.stop();
            }else{
                this.wrap.classList.remove("resource-slider--pause");
                this.playing = true;
                this.start();
            }
        })
    }


    start(){
        this.progressBar.style.width= `100%`;
        this.interval = setInterval(this.slide, 8200);
    }

    stop(){
        this.progressBar.style.width= `0%`;
        clearInterval(this.interval);
    }

}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-resource-slider]').forEach(i => {
        let theSlider = new ResourceSlider(i,
            i.querySelector('[data-items]'),
            i.querySelector('[data-controls]'),
            i.querySelector('[data-count]'),
            i.querySelector('[data-play]'),
            i.querySelector('[data-progress]')
        );
        i.sliderFunc = theSlider;
    })
});
class Results {

    constructor(element) {
        this.filter = element.querySelector(`[data-filter]`);
        this.buttons = this.filter.querySelectorAll(`[data-tab]`);

        this.itemWrap = element.querySelector(`[data-items]`);
        this.items = this.itemWrap.querySelectorAll(`[data-cat-id]`);

        this.bindEvents();
        this.init();
    }

    init() {
        this.buttons.forEach(el => {
            el.catId = el.dataset.catId;
        });
        this.items.forEach(el => {
            el.catIds = el.dataset.catId.split(",");
        });
    }

    bindEvents() {
        this.buttons.forEach(el => {
            el.addEventListener('click', () => {
                this.showItems(el)
            })
        });
    }

    showItems(button) {

        const catId = button.catId;

        this.buttons.forEach(el => {
            el.classList.remove('active');
        });
        button.classList.add('active');

        this.items.forEach(el => {
            el.classList.remove('hidden');
        });
        if (catId !== undefined) {
            Array.from(this.items).filter(el => {
                if (el.catIds.includes(catId) === false) {
                    el.classList.add('hidden')
                }
            });
        }
    }

}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(`[data-results]`).forEach(el => {
        new Results(el)
    });
});
class ScrollTo {

    constructor(element, options = {}) {
        this.element = element;
        this.options = options;
        this.targetElement = document.querySelector(this.element.dataset.scrollTo);

        this.defaultOptions = {
            offsetAmount: 0
        };

        this.finalOptions = {...this.defaultOptions, ...this.options};

        this.init();

        if (this.targetElement !== null) {
            this.bindEvents();
        } else {
            console.error('ScrollTo target not found', this.element);
        }

    }

    init() {
        this.offsetAmount = parseInt(this.finalOptions.offsetAmount);
    }

    bindEvents() {
        if (this.element.hasScrollTo === true) {
            return false
        }

        this.element.addEventListener('click', (event) => this.doScroll(event));
        this.element.hasScrollTo = true;
    }

    doScroll(event) {


        event.preventDefault();

        const headerHeight = getComputedStyle(document.querySelector('.header')).height;
        const scrollPosition = this.targetElement.offsetTop;
        const scrollTo = (scrollPosition - parseInt(headerHeight) + this.offsetAmount);

        if (isIE11) {
            window.scrollTo(0, scrollTo);
        } else {
            window.scrollTo({top: scrollTo, behavior: 'smooth'});
        }

    }

}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-scroll-to]').forEach(el => new ScrollTo(el));
});
document.querySelectorAll(`[data-select-type="choicesjs"]`).forEach(el => {

    //only apply choices JS, if not in modal placeholder area 'modalcontent'
    if (el.closest(".modalcontent") === null) {

        let options = {
            removeItemButton: true,
            itemSelectText: "",
            placeholderValue: "Please select...",
            searchPlaceholderValue: "Type to filter..."
        }

        if (el.dataset.noFilter !== undefined) {
            options.searchEnabled = false
        }

        let choices = new Choices(el, options);
    }

});
class Slider extends BaseClass {
    constructor(i, items, controls, nav) {
        super(i);
        this.wrap = i;
        this.items = items;
        this.nav = nav;
        this.controls = controls;
        this.style = this.wrap.dataset.slider;
        this.controltoggle = this.wrap.dataset.controltoggle;
        this.options = {};

        this.buildSlider();
    }

    buildSlider() {

        let options = {};

        switch (this.style) {
            case "1":
                options = {
                    nav: false,
                    container: this.items,
                    arrowKeys: this.controltoggle,
                    controls: this.controltoggle,
                    controlsContainer: this.controls,
                    speed: 500,
                    autoHeight: true,
                    loop: false,
                    responsive: {
                        768: {
                            items: 2,
                            gutter: 60
                        },
                        992: {
                            gutter: 120
                        },
                        1440: {
                            gutter: 280
                        }
                    }
                };
                break;
            case "2":
                options = {
                    navContainer: this.nav,
                    container: this.items,
                    arrowKeys: this.controltoggle,
                    controls: this.controltoggle,
                    controlsPosition: "bottom",
                    navPosition: "bottom",
                    speed: 500,
                    autoHeight: true,
                    slideBy: 1,
                    items: 1,
                    edgePadding: 50,
                    fixedWidth: 400,
                    mouseDrag: true,
                    loop: true
                };
                break;
            default:
                options = {
                    container: this.wrap
                }
        }

        this.sliderObject = tns(options);

        this.wrap.sliderFunc = this.sliderObject;

        this.resizeFunction = debounce(e => {
            this.sliderObject.updateSliderHeight();
            this.raiseEvent("resized");
        }, 500).bind(this);

        window.addEventListener("resize", e => {
            this.resizeFunction();
        });


    }

}

document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('[data-slider]').forEach(i => {

        let theSlider = new Slider(i,
            i.querySelector('[data-items]'),
            i.querySelector('[data-controls]'),
            i.querySelector('[data-nav]')
        );
        i.sliderFunc = theSlider;

    })
});
document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('[data-story-slider]').forEach(i => {

        if (i.sliderInit) {
            return false
        }

        i.sliderInit = true;

        const counter = i.querySelector('[data-count]');

        const removeGutter = (width) => width - (15 * 2);

        let slider = tns({
            nav: false,
            container: i.querySelector('[data-items]'),
            controlsContainer: i.querySelector('[data-controls]'),
            loop: true,
            gutter: 40,
            responsive: {
                576: {
                    fixedWidth: removeGutter(540),
                    center: true
                },
                768: {
                    fixedWidth: removeGutter(720)
                },
                992: {
                    fixedWidth: removeGutter(960)
                },
                1200: {
                    fixedWidth: removeGutter(1140)
                },
                1440: {
                    gutter: 120,
                    fixedWidth: (removeGutter(1300) - (120 + 40 + 20))
                }
            }
        });

        slider.events.on("transitionEnd", data => counter.innerText = `${data.displayIndex} of ${data.slideCount}`);

        i.sliderFunc = slider;

    });

});

document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('[data-testimonial-slider]').forEach(i => {
        let theTestimonialSlider = new TestimonialSlider(i,
            i.querySelector('[data-testimonial-items]'),
            i.querySelector('[data-testimonial-controls]'),
            i.querySelector('[data-testimonial-nav]')
        );
        i.sliderFunc = theTestimonialSlider;
        
    });

});
class TestimonialSlider extends BaseClass {
    constructor(i, items, controls, nav) {
        super(i);
        this.wrap = i;
        this.items = items;
        this.nav = nav;
        this.controls = controls;
        this.style = this.wrap.dataset.slider;
        this.controltoggle = this.wrap.dataset.controltoggle;
        this.options = {};

        this.buildTestimonialSlider();
    }

    buildTestimonialSlider() {

        let options = {};

        options = {
            navContainer: this.nav,
            container: this.items,
            arrowKeys: this.controltoggle,
            controls: this.controltoggle,
            controlsPosition: "bottom",
            navPosition: "bottom",
            
            items: 1,
            slideBy: "page",
            mouseDrag: true,
            swipeAngle: false,
            speed: 400,
            edgePadding: 30,
            gutter: 20,
            responsive: {
               500: {
                    edgePadding: 50,
                    gutter: 80
                }
            }
            
        };

        this.sliderObject = tns(options);

   


    }

}
class TabWrap{
    constructor(el) {
        this.scope = el;
        this.tabs = el.querySelectorAll("[data-tab]");
        this.content = el.querySelectorAll("[data-content]");

        this.bindEvents();
    }

    bindEvents(){
        this.tabs.forEach((tab, i) =>{
            tab.addEventListener("click", ()=>{
                this.toggleContent(i)
            })
        })
    }

    toggleContent(target){
        this.tabs.forEach((tab, i) =>{
            if(i === target){
                tab.classList.add("tabs-2__tab--open");
            }else{
                tab.classList.remove("tabs-2__tab--open");
            }
        })
        this.content.forEach((item, i) =>{
            if(i === target){
                item.classList.add("tab-wrap__content--open");
            }else{
                item.classList.remove("tab-wrap__content--open");
            }
        })
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(`[data-tab-wrap]`).forEach(el => {
        new TabWrap(el);
    });
});
document.addEventListener('DOMContentLoaded', () => {

    document.querySelectorAll('[data-tooltip]').forEach(el => {
        tippy(el,{
            content: el.dataset.tooltip
        })
    })

});

class Video {
    constructor(el) {
        this.component = el;
        this.videoTemplate = this.component.querySelector(`[data-video-content]`);
        this.showVideoButton = this.component.querySelector(`[data-load-video-button]`);
        this.bindEvents();
    }

    bindEvents() {
        this.showVideoButton.addEventListener(
            'click',
            () => this.addVideo(),
            {once: true}
        );
    }

    addVideo() {
        const video = this.videoTemplate.innerHTML;
        this.component.insertAdjacentHTML(`beforeend`, video);
        this.component.classList.add('video--overlay-closed');
        this.videoTemplate.remove();
    }

}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(`[data-video][data-video-masked]`).forEach(el => new Video(el));
});
//# sourceMappingURL=script.js.map